import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=09048c79&scoped=true&"
import script from "./FilePicker.vue?vue&type=script&lang=js&"
export * from "./FilePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../axxez-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09048c79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../axxez-dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VContainer,VFileInput,VIcon,VImg,VRow})
